export default __webpack_public_path__ + "static/media/logo__technology__node.654603e9.png";